'use client';

import React from 'react';

import { useGlobalClientContext } from '../common/GlobalClientContext';

export default function Bottom() {
  const {
    i18nHelper: { t }
  } = useGlobalClientContext();

  const interestHref = `/talk-to-expert`;

  return (
    <div className="w-full h-fit bg-gray-900 py-[80px] flex flex-col items-center justify-center">
      <div className="font-display font-semibold text-3xl leading-8xl text-primaryInverse">
        {t('home.bottom.title', {})}
      </div>
      <div className="mt-l font-regular text-xl leading-3xl text-primaryInverse">
        {t('home.bottom.description', {})}
      </div>
      <a
        href={interestHref}
        className="h-[48px] items-center mt-5xl bg-cic-blue-500 w-fit rounded-sm hover:bg-[#0497E4] hover:no-underline active:bg-[#0686C8] px-xl py-m font-display font-semibold text-md leading-sm text-primaryInverse">
        {t('talk_to_expert.capitalize', {})}
      </a>
    </div>
  );
}
